module.exports = __webpack_public_path__ + "static/media/mapMarker.da7e6b80.svg";